import { RouteIcon } from '../../../../../RouteIcons/';
import { MARKER_ICON } from '../../../../../RouteIcons/shipmentSegment';

import { CurrentPosition, MarkerLabel, MarkerWrapper } from './styles';

interface MarkerProps {
  label: string;
  isCurrent: boolean;
  routeIcon?: string;
  icon: MARKER_ICON;
}

export const TOOLTIP_THEME = {
  default: 'neutral.700',
  primary: 'fill.cerulean.700',
};

export const getLabelColor = (icon: string): string =>
  MARKER_ICON.FUTURE_EVENT === icon
    ? TOOLTIP_THEME.default
    : TOOLTIP_THEME.primary;

const Marker = ({ isCurrent, routeIcon, label, icon }: MarkerProps) => {
  return isCurrent ? (
    <CurrentPosition data-testid="shipment-map-marker-current">
      <RouteIcon name={String(routeIcon)} />
      <MarkerLabel css={{ background: TOOLTIP_THEME.primary, left: '150%' }}>
        {label}
      </MarkerLabel>
    </CurrentPosition>
  ) : (
    <MarkerWrapper
      data-testid="shipment-map-marker"
      complete={icon === MARKER_ICON.PAST_EVENT}
    >
      <RouteIcon name="locationmark" />
      <MarkerLabel css={{ background: getLabelColor(icon) }}>
        {label}
      </MarkerLabel>
    </MarkerWrapper>
  );
};

export default Marker;
